import { CheckCircle2, FileWarning } from "lucide-react";

export default function PageFit({ fit }) {
  const pct = Math.min(100, (fit.pages / Math.max(fit.target, fit.pages)) * 100);
  return (
    <div data-testid="page-fit" className={`rounded-xl border p-4 ${fit.fits ? "border-emerald-500/30 bg-emerald-500/5" : "border-amber-500/40 bg-amber-500/5"}`}>
      <div className="flex items-center gap-3">
        {fit.fits ? <CheckCircle2 size={18} className="text-emerald-400" /> : <FileWarning size={18} className="text-amber-400" />}
        <div className="font-semibold" data-testid="page-fit-text">About {fit.pages} page{fit.pages === 1 ? "" : "s"} · target {fit.target} page{fit.target > 1 ? "s" : ""}</div>
        <div className="ml-auto text-xs text-slate-400">{fit.fits ? "Fits" : "Too long"}</div>
      </div>
      <div className="h-1.5 rounded-full bg-slate-800 mt-3 overflow-hidden">
        <div className={`h-full transition-[width] duration-500 ${fit.fits ? "bg-emerald-500" : "bg-amber-500"}`} style={{ width: `${pct}%` }} />
      </div>
      {fit.tips.length > 0 && (
        <ul className="mt-3 space-y-1 text-sm text-amber-200" data-testid="page-fit-tips">
          {fit.tips.map((t) => <li key={t}>• {t}</li>)}
        </ul>
      )}
    </div>
  );
}
